export default __webpack_public_path__ + "static/media/7-link-to-webpage.30afe7f4.png";